export default {
  studentButton: {
    showContextMenu: false //为true表示PC端右键时显示彻查作业的el-popover
  }
}
